var map = {
	"./KPMG-Logo.jpg": 162,
	"./Oracle_Logo_1.png": 163,
	"./Pluralsight_logo.jpg": 164,
	"./Udemy_logo.png": 165,
	"./address_image.svg": 166,
	"./animated_kritagya.png": 167,
	"./animated_logo.svg": 168,
	"./aws_ccp_exam.png": 169,
	"./blogs_image.svg": 170,
	"./bvicam_logo.png": 171,
	"./calstatela.png": 172,
	"./cloud_infrastructure.svg": 173,
	"./codeInLogo.png": 174,
	"./coding-blocks_logo.png": 175,
	"./contactMail.png": 176,
	"./coursera_logo.png": 177,
	"./cube_highways_logo.jpg": 178,
	"./data_science.svg": 179,
	"./deeplearning_ai_logo.png": 180,
	"./delhivery_logo.png": 181,
	"./developerActivity.svg": 182,
	"./dsc_logo.png": 183,
	"./education.svg": 184,
	"./experience.svg": 185,
	"./feelingProud.svg": 186,
	"./freecopy_logo.png": 187,
	"./fullstack.svg": 188,
	"./gannon_irb.png": 189,
	"./gcp_logo.png": 190,
	"./github_logo.png": 191,
	"./gndu_logo.png": 192,
	"./googleAssistant.jpg": 193,
	"./googleAssistant.svg": 194,
	"./google_logo.png": 195,
	"./ibm_logo.png": 196,
	"./intel_logo.jpg": 197,
	"./jsFramework.svg": 198,
	"./legato_logo.png": 199,
	"./manOnTable.svg": 200,
	"./microsoft_logo.png": 201,
	"./mozilla_logo.png": 202,
	"./muffito_logo.png": 203,
	"./nextuLogo.jpg": 204,
	"./niit_logo.png": 205,
	"./nptel_logo.png": 206,
	"./oracle_logo.png": 207,
	"./portfolio.gif": 208,
	"./programmer.svg": 209,
	"./projects_image.svg": 210,
	"./pwa.png": 211,
	"./saayaHealthLogo.png": 212,
	"./stanford_logo.png": 213,
	"./talksCardBack.svg": 214,
	"./talksCardBackAlt.svg": 215,
	"./ui_ux_design.svg": 216,
	"./uieducon.jpeg": 217,
	"./vmm-education_logo.jpg": 218
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 53;